export class FilterToken {
  static IFilterRepository = Symbol("IFilterRepository");
  static FilterUseCase = Symbol("FilterUseCase");
}
